export const SAMPLE_EMPTY_SET = new Set();

/* prettier-ignore */
export const SAMPLE_SETS = [
	SAMPLE_EMPTY_SET,
	new Set([1, 2, 2])
] as const;
